import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { Account } from './account';
import { Dataset, ModifyDatasetAction } from "types/dataset";
import store from "store/store";
import i18n from "i18n";
import { showSnackbar } from "./snackbarHelper";
import { AccountRole } from "types/account";
import { useNavigate } from "react-router-dom";
import { globalNavigate } from "components/Navigator";





//const apiUrl =  'http://localhost:5200'
const apiUrl =  'https://saasragtestserver.mi-expert.com'
export enum ERROR_MESSAGE {
  EMAIL_NOT_FOUND = 'Email not found',
  INVALID_PASSWORD = 'Invalid password',
  INVALID_EMAIL_OR_PASSWORD = 'Invalid email or password',
  SECRET_KEY_EXPIRED = 'SecretKey expired'
}


const account = new Account()
const api = axios.create({
  baseURL: apiUrl, 
  timeout: 60000,
  headers: {
    'X-API-KEY':'miexpertRAGsaasTestserver',
    'Authorization': localStorage?.account&&JSON.parse(localStorage.account).secretKey
  }
});

const handlerError = (error: AxiosError|string) => {
  if (typeof error !== 'string' && (error.status === 401)){
    showSnackbar(i18n.t((error.response as any ).data.error, { ns:'validation' }), "error");
    account.clearAccount()
    globalNavigate('/app/signin')
    return (error.response as any).data
  } else if (typeof error==='string'){
    showSnackbar(i18n.t(error, { ns:'validation' }), "error");
    return error
  } else {
    if (error.response){
      showSnackbar(i18n.t((error.response as any ).data.error, { ns:'validation' }), "error"); 
      return (error.response as any )?.data
    }
    
    return { error: error.message }
  }
}

const getMethod = (endpoint:string, params:any, option:AxiosRequestConfig = {}) =>{
  
  return api.get(endpoint, {params, ...option})
  .then((resp: AxiosResponse) => {
    if (resp.data.error){
      throw resp.data.error
    }
    return resp.data
  })
  .catch((error: AxiosError) => {
    return handlerError(error);
  });
}
const postMethod = (endpoint: string, params: Object, option:AxiosRequestConfig = null) =>{
  const data = new FormData();
  
  for (let [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined) {
        if (value instanceof File) {
            data.append(key, value); // Directly append File objects
        } else if (typeof value === 'object' && !(value instanceof File)) {
            data.append(key, JSON.stringify(value)); // Stringify nested objects
        } else {
            data.append(key, value as string); // Append other types as strings
        }
    }
}
  
  return api.post(endpoint, data, option)
    .then((resp: AxiosResponse) => {
      if (resp.data.error){
        throw resp.data.error;
      }
      return resp.data
    })
    .catch((error: AxiosError) => {
      return handlerError(error)
    })
}


/**
 * Logs in a user and returns the user's information.
 * @param email The user's email address
 * @param password The user's password
 * @returns The user's information on success, otherwise an error
 */
export const login = (email:string, password:string) => {
  return postMethod('/login', {email, password})
}

export const register = (username:string, password:string, email:string, role:AccountRole, verification_code:string, resend:boolean) => {
  return postMethod('/register', {username, password, email, role, verification_code, resend})
}
export const forgotPassword = (password:string, email:string,  verification_code:string) => {
  return postMethod('/forgotPassword', { password, email, verification_code})
}
export const updateToken = () =>{
  return getMethod('/renewSecretKey', {})
}

/**
 * Get an answer from the server based on a question and dataset.
 * @param question The question to ask the server
 * @param dataset The dataset to use for generating the answer
 * @param channel The channel to use for generating the answer (optional)
 * @returns a promise that resolves with the answer
 */
export const answerEndpoint = (question:string, dataset:string, channel?:string) =>{
 return postMethod('/answer', {question, dataset, channel}, { timeout : 0 }).then((resp)=>{
  
  if (resp?.credit!==undefined) {
    account.setCredit(resp.credit)
  }
  return resp
 })
}

export const createDataset = (req:Dataset) => {
  return postMethod('/createDataset', {...req})
}

/**
 * This endpoint retrieves the list of datasets that the user can access.
 * @returns a promise that resolves with the list of datasets
 */
export const getDatasetList = () => {
  return getMethod('/getDatasetList',{}).then((resp)=>{
    if (resp?.credit!==undefined) {
      account.setCredit(resp.credit)
    }
    return resp
  })
}

/**
 * Modifies a dataset.
 * @param datasetId The ID of the dataset to modify
 * @param action The action to perform on the dataset (delete, updateInfo, removeFile, addDocument, getFileList, getInfo)
 * @param req The request parameters for the action being performed
 * @returns a promise that resolves when the action has been performed
 */
export const modifyDataset = (datasetId:string,action: ModifyDatasetAction, req:any) =>{
  return postMethod('/modifyDataset',{ ...req, datasetId, action})
}



export const updateDataset = (datasetId:string, req: Dataset)=>{
  return modifyDataset(datasetId, 'updateInfo', {...req})
}

/**
 * Retrieves the list of files in the given dataset.
 * @param datasetId The ID of the dataset to retrieve the file list for
 * @returns a promise that resolves with the list of files
 */
export const getDatasetFileList = (datasetId:string) =>{
  return modifyDataset(datasetId, 'getFileList', {})
}

/**
 * Deletes a dataset.
 * @param datasetId The ID of the dataset to delete
 * @returns a promise that resolves when the dataset has been deleted
 */
export const deleteDataset = (datasetId:string) =>{
  return modifyDataset(datasetId, 'delete', {})
}

/**
 * Removes a file from a dataset.
 * @param datasetId The ID of the dataset to remove the file from
 * @param fileId The ID of the file to remove
 */
export const removeDatasetFile = (datasetId:string, fileId:string) => {
  return modifyDataset(datasetId, 'removeFile', { fileId })
}

/**
 * Send a file to the server to add to the dataset.
 * @param dataset name of the dataset to add the file to
 * @param file the file to add (p.s. only .pdf and .txt files are supported)
 * @returns a promise that resolves when the file has been added
 */
export const addDocument = (dataset:string, uploadFile:File | string) =>{
  const file = uploadFile instanceof File ? uploadFile : null
  console.log(uploadFile)
  const url = typeof uploadFile === 'string' ? uploadFile : ''
  return postMethod('/addDocument', { dataset, file, url }, { timeout : 0 })
}

/**
 * Get the chat history for a given channel
 * @param channel The channel to retrieve the chat history for
 * @returns a promise that resolves with the chat history
 */
export const getChatHistory = (channel:string) =>{
  return getMethod('/getOldChatHistory', {channel}).then((resp)=>{
    if (resp?.credit!==undefined) {
      account.setCredit(resp.credit)
    }
    return resp
   })
}

export const getAllLastMessages = () => {
  return getMethod('/getAllLastMessages', {})
}


export const createOrganizationUser = (organizationId:string, username:string ) => {
  return postMethod('/createOrganizationUser', {organizationId, username})
}

export const suspendOrganizationUser = (organizationId:string, userId:string, action:'suspend'|'reactivate') => {
  return postMethod('/suspendOrganizationUser',{organizationId, userId, action})
}

export const transferCredit = (organizationId:string, userId:string, amount:number) => {
  return postMethod('/transferCredit',{organizationId, userId, amount})
}

export const upgradeUser = (userId:string) =>{
  return postMethod('/upgradeUser', {userId})
}

export const generateOrganizationUserSecret = (organizationId:string, userId:string, expireDays:number = 7) => {
  return postMethod('/generateOrganizationUserSecret',{organizationId, userId, expireDays})
} 

export const createOrganization = (organizationName:string) =>{
  return postMethod('/createOrganization',{organizationName})
}

export const getOrganizationsByAdminId = () => {
  return getMethod('/getOrganizationsByAdminId', {})
}

export const modifyOrganizationName = (organizationId:string,newOrganizationName:string) =>{
  return postMethod('/modifyOrganizationName',{organizationId, newOrganizationName})
}

export const getOrganizationUsers = (organizationId:string) =>{
  return getMethod('/getOrganizationUsers',{organizationId})
}

export const updateOrganizationUserInfo = (organizationId:string, organizationUserId:string, useAdminCredit:boolean) => {
  return postMethod('/updateOrganizationUserInfo',{organizationId,organizationUserId,useAdminCredit})
}

export const getUserData = (secretKey:string) => {
  return getMethod('/getUserData', {}, {
    headers: {
      'Authorization': secretKey
    }
  })
}
export const getOrganizationData = (organizationId:string) => {
  return getMethod('/getOrganizationData', {organizationId})
}

export const exportChatHistory = (userIds:string[]) => {
  return postMethod('/exportChatHistory', {userIds})
}
